import React from 'react';
import i18n from '@i18n';
import { LoginForm } from '@/loginng/views/LoginDialog';

import './TicketLoginForm.less';

export function TicketLoginForm() {
    return (
        <div className="ticket-login-form">
            <p>{i18n('tickets.login-info')}</p>
            <LoginForm registerInfo={false} loginOrigin="inPage" />
        </div>
    );
}
